import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';

import {
  types as sdkTypes,
  createImageVariantConfig,
} from '../../util/sdkLoader';
import { findNextBoundary, getStartOf, monthIdString } from '../../util/dates';
import {
  isTransactionsTransitionInvalidTransition,
  storableError,
} from '../../util/errors';
import { getAdminConfigApi, isUsersEmailVerifiedApi, onSendPushNotification, syncBadgeCount, sendEmailToSupportApi, sendMessageNotificationToOtherPartyApi, transactionLineItems, updateAdminConfigAnalyticsDataApi, updateAlgoliaData } from '../../util/api';
import * as log from '../../util/log';
import {
  updatedEntities,
  denormalisedEntities,
  denormalisedResponseEntities,
} from '../../util/data';
import {
  resolveLatestProcessName,
  getProcess,
  isBookingProcess,
} from '../../transactions/transaction';

import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUser, fetchCurrentUserNotifications } from '../../ducks/user.duck';
import { transitions } from '../../transactions/transactionProcessBooking';
import moment from 'moment';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { getAlgoliaIndexNameForLang } from '../../util/urlHelpers';
import { UNREAD_MESSAGES_ROLE_ORDER, UNREAD_MESSAGES_ROLE_SALES, oneSignalNotificationTemplates } from '../../util/constants';
const { UUID } = sdkTypes;

const MESSAGES_PAGE_SIZE = 100;
const REVIEW_TX_INCLUDES = ['reviews', 'reviews.author', 'reviews.subject'];
const getItemListingIdString = value =>
  typeof value === 'string'
    ? value
    : value && typeof value === 'object' && typeof value.uuid === 'string'
      ? value.uuid
      : null;

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/TransactionPage/SET_INITIAL_VALUES';
export const SET_USERS_EMAIL_VERIFIED = 'app/TransactionPage/SET_USERS_EMAIL_VERIFIED';
export const FETCH_TRANSACTION_REQUEST =
  'app/TransactionPage/FETCH_TRANSACTION_REQUEST';
export const FETCH_TRANSACTION_SUCCESS =
  'app/TransactionPage/FETCH_TRANSACTION_SUCCESS';
export const FETCH_TRANSACTION_ERROR =
  'app/TransactionPage/FETCH_TRANSACTION_ERROR';

export const FETCH_TRANSITIONS_REQUEST =
  'app/TransactionPage/FETCH_TRANSITIONS_REQUEST';
export const FETCH_TRANSITIONS_SUCCESS =
  'app/TransactionPage/FETCH_TRANSITIONS_SUCCESS';
export const FETCH_TRANSITIONS_ERROR =
  'app/TransactionPage/FETCH_TRANSITIONS_ERROR';

export const TRANSITION_REQUEST = 'app/TransactionPage/MARK_RECEIVED_REQUEST';
export const TRANSITION_SUCCESS = 'app/TransactionPage/TRANSITION_SUCCESS';
export const TRANSITION_ERROR = 'app/TransactionPage/TRANSITION_ERROR';

export const FETCH_MESSAGES_REQUEST =
  'app/TransactionPage/FETCH_MESSAGES_REQUEST';
export const FETCH_MESSAGES_SUCCESS =
  'app/TransactionPage/FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_ERROR = 'app/TransactionPage/FETCH_MESSAGES_ERROR';

export const SEND_MESSAGE_REQUEST = 'app/TransactionPage/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'app/TransactionPage/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'app/TransactionPage/SEND_MESSAGE_ERROR';

export const SEND_REVIEW_REQUEST = 'app/TransactionPage/SEND_REVIEW_REQUEST';
export const SEND_REVIEW_SUCCESS = 'app/TransactionPage/SEND_REVIEW_SUCCESS';
export const SEND_REVIEW_ERROR = 'app/TransactionPage/SEND_REVIEW_ERROR';

export const FETCH_TIME_SLOTS_REQUEST =
  'app/TransactionPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS =
  'app/TransactionPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR =
  'app/TransactionPage/FETCH_TIME_SLOTS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST =
  'app/TransactionPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS =
  'app/TransactionPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR =
  'app/TransactionPage/FETCH_LINE_ITEMS_ERROR';

export const FETCH_ADMIN_CONFIG_REQUEST =
  'app/TransactionPage/FETCH_ADMIN_CONFIG_REQUEST';
export const FETCH_ADMIN_CONFIG_SUCCESS =
  'app/TransactionPage/FETCH_ADMIN_CONFIG_SUCCESS';
export const FETCH_ADMIN_CONFIG_ERROR =
  'app/TransactionPage/FETCH_ADMIN_CONFIG_ERROR';

export const SEND_EMAIL_TO_SUPPORT_SUCCESS =
  'app/TransactionPage/SEND_EMAIL_TO_SUPPORT_SUCCESS';
// ================ Reducer ================ //

const initialState = {
  fetchTransactionInProgress: false,
  fetchTransactionError: null,
  transactionRef: null,
  transitionInProgress: null,
  transitionError: null,
  fetchMessagesInProgress: false,
  fetchMessagesError: null,
  totalMessages: 0,
  totalMessagePages: 0,
  oldestMessagePageFetched: 0,
  messages: [],
  initialMessageFailedToTransaction: null,
  savePaymentMethodFailed: false,
  sendMessageInProgress: false,
  sendMessageError: null,
  sendReviewInProgress: false,
  sendReviewError: null,
  monthlyTimeSlots: {
    // '2022-03': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  fetchTransitionsInProgress: false,
  fetchTransitionsError: null,
  processTransitions: null,
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  usersEmailVerified: {},
  adminConfig: null,
  fetchAdminConfigInProgress: false,
  fetchAdminConfigError: null,
  sendEmailToSupportSuccess: null,
};

// Merge entity arrays using ids, so that conflicting items in newer array (b) overwrite old values (a).
// const a = [{ id: { uuid: 1 } }, { id: { uuid: 3 } }];
// const b = [{ id: : { uuid: 2 } }, { id: : { uuid: 1 } }];
// mergeEntityArrays(a, b)
// => [{ id: { uuid: 3 } }, { id: : { uuid: 2 } }, { id: : { uuid: 1 } }]
const mergeEntityArrays = (a, b) => {
  return a
    .filter(aEntity => !b.find(bEntity => aEntity.id.uuid === bEntity.id.uuid))
    .concat(b);
};

export default function transactionPageReducer(
  state = initialState,
  action = {}
) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case FETCH_TRANSACTION_REQUEST:
      return {
        ...state,
        fetchTransactionInProgress: true,
        fetchTransactionError: null,
      };
    case FETCH_TRANSACTION_SUCCESS: {
      const transactionRef = { id: payload.data.data.id, type: 'transaction' };
      return { ...state, fetchTransactionInProgress: false, transactionRef };
    }
    case FETCH_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        fetchTransactionInProgress: false,
        fetchTransactionError: payload,
      };

    case FETCH_TRANSITIONS_REQUEST:
      return {
        ...state,
        fetchTransitionsInProgress: true,
        fetchTransitionsError: null,
      };
    case FETCH_TRANSITIONS_SUCCESS:
      return {
        ...state,
        fetchTransitionsInProgress: false,
        processTransitions: payload,
      };
    case FETCH_TRANSITIONS_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        fetchTransitionsInProgress: false,
        fetchTransitionsError: payload,
      };

    case TRANSITION_REQUEST:
      return {
        ...state,
        transitionInProgress: payload,
        transitionError: null,
      };
    case TRANSITION_SUCCESS:
      return { ...state, transitionInProgress: null };
    case TRANSITION_ERROR:
      return {
        ...state,
        transitionInProgress: null,
        transitionError: payload,
      };

    case FETCH_MESSAGES_REQUEST:
      return {
        ...state,
        fetchMessagesInProgress: true,
        fetchMessagesError: null,
      };
    case FETCH_MESSAGES_SUCCESS: {
      const oldestMessagePageFetched =
        state.oldestMessagePageFetched > payload.page
          ? state.oldestMessagePageFetched
          : payload.page;
      return {
        ...state,
        fetchMessagesInProgress: false,
        messages: mergeEntityArrays(state.messages, payload.messages),
        totalMessages: payload.totalItems,
        totalMessagePages: payload.totalPages,
        oldestMessagePageFetched,
      };
    }
    case FETCH_MESSAGES_ERROR:
      return {
        ...state,
        fetchMessagesInProgress: false,
        fetchMessagesError: payload,
      };

    case SEND_MESSAGE_REQUEST:
      return {
        ...state,
        sendMessageInProgress: true,
        sendMessageError: null,
        initialMessageFailedToTransaction: null,
      };
    case SEND_MESSAGE_SUCCESS:
      return { ...state, sendMessageInProgress: false };
    case SEND_MESSAGE_ERROR:
      return {
        ...state,
        sendMessageInProgress: false,
        sendMessageError: payload,
      };

    case SEND_REVIEW_REQUEST:
      return { ...state, sendReviewInProgress: true, sendReviewError: null };
    case SEND_REVIEW_SUCCESS:
      return { ...state, sendReviewInProgress: false };
    case SEND_REVIEW_ERROR:
      return {
        ...state,
        sendReviewInProgress: false,
        sendReviewError: payload,
      };

    case FETCH_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots };
    }

    case FETCH_LINE_ITEMS_REQUEST:
      return {
        ...state,
        fetchLineItemsInProgress: true,
        fetchLineItemsError: null,
      };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return {
        ...state,
        fetchLineItemsInProgress: false,
        fetchLineItemsError: payload,
      };
    case FETCH_ADMIN_CONFIG_REQUEST:
      return { ...state, fetchAdminConfigInProgress: true, fetchAdminConfigError: null };
    case FETCH_ADMIN_CONFIG_SUCCESS:
      return { ...state, fetchAdminConfigInProgress: false, adminConfig: payload, fetchAdminConfigError: null };
    case FETCH_ADMIN_CONFIG_ERROR:
      return { ...state, fetchAdminConfigInProgress: false, fetchAdminConfigError: payload };
    case SET_USERS_EMAIL_VERIFIED:
      return { ...state, usersEmailVerified: payload };
    case SEND_EMAIL_TO_SUPPORT_SUCCESS:
      return { ...state, sendEmailToSupportSuccess: true };
    default:
      return state;
  }
}

// ================ Selectors ================ //

export const transitionInProgress = state => {
  return state.TransactionPage.transitionInProgress;
};

// ================ Action creators ================ //
export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const fetchTransactionRequest = () => ({ type: FETCH_TRANSACTION_REQUEST });
const fetchTransactionSuccess = response => ({
  type: FETCH_TRANSACTION_SUCCESS,
  payload: response,
});
const fetchTransactionError = e => ({
  type: FETCH_TRANSACTION_ERROR,
  error: true,
  payload: e,
});

const fetchTransitionsRequest = () => ({ type: FETCH_TRANSITIONS_REQUEST });
const fetchTransitionsSuccess = response => ({
  type: FETCH_TRANSITIONS_SUCCESS,
  payload: response,
});
const fetchTransitionsError = e => ({
  type: FETCH_TRANSITIONS_ERROR,
  error: true,
  payload: e,
});

const transitionRequest = transitionName => ({
  type: TRANSITION_REQUEST,
  payload: transitionName,
});
const transitionSuccess = () => ({ type: TRANSITION_SUCCESS });
const transitionError = e => ({
  type: TRANSITION_ERROR,
  error: true,
  payload: e,
});

const fetchMessagesRequest = () => ({ type: FETCH_MESSAGES_REQUEST });
const fetchMessagesSuccess = (messages, pagination) => ({
  type: FETCH_MESSAGES_SUCCESS,
  payload: { messages, ...pagination },
});
const fetchMessagesError = e => ({
  type: FETCH_MESSAGES_ERROR,
  error: true,
  payload: e,
});

const sendMessageRequest = () => ({ type: SEND_MESSAGE_REQUEST });
const sendMessageSuccess = () => ({ type: SEND_MESSAGE_SUCCESS });
const sendMessageError = e => ({
  type: SEND_MESSAGE_ERROR,
  error: true,
  payload: e,
});

const sendReviewRequest = () => ({ type: SEND_REVIEW_REQUEST });
const sendReviewSuccess = () => ({ type: SEND_REVIEW_SUCCESS });
const sendReviewError = e => ({
  type: SEND_REVIEW_ERROR,
  error: true,
  payload: e,
});

export const fetchTimeSlotsRequest = monthId => ({
  type: FETCH_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchTimeSlotsError = (monthId, error) => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

export const fetchAdminConfigRequest = () => ({ type: FETCH_ADMIN_CONFIG_REQUEST });
export const fetchAdminConfigSuccess = adminConfig => ({
  type: FETCH_ADMIN_CONFIG_SUCCESS,
  payload: adminConfig,
});
export const fetchAdminConfigError = error => ({
  type: FETCH_ADMIN_CONFIG_ERROR,
  error: true,
  payload: error,
});
export const setUsersEmailVerified = usersEmailVerified => ({
  type: SET_USERS_EMAIL_VERIFIED,
  payload: usersEmailVerified,
});
export const sendEmailToSupportSuccess = () => ({
  type: SEND_EMAIL_TO_SUPPORT_SUCCESS,
});
// ================ Thunks ================ //

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = (listingId, start, end, timeZone) => (
  dispatch,
  getState,
  sdk
) => {
  const monthId = monthIdString(start, timeZone);

  dispatch(fetchTimeSlotsRequest(monthId));

  // The maximum pagination page size for timeSlots is 500
  const extraParams = {
    perPage: 500,
    page: 1,
  };

  return dispatch(timeSlotsRequest({ listingId, start, end, ...extraParams }))
    .then(timeSlots => {
      dispatch(fetchTimeSlotsSuccess(monthId, timeSlots));
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(monthId, storableError(e)));
    });
};

// Helper function for loadData call.
const fetchMonthlyTimeSlots = (dispatch, listing) => {
  const hasWindow = typeof window !== 'undefined';
  const attributes = listing.attributes;
  // Listing could be ownListing entity too, so we just check if attributes key exists
  const hasTimeZone =
    attributes &&
    attributes.availabilityPlan &&
    attributes.availabilityPlan.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && hasTimeZone) {
    const tz = listing.attributes.availabilityPlan.timezone;
    const nextBoundary = findNextBoundary(new Date(), 'hour', tz);

    const nextMonth = getStartOf(nextBoundary, 'month', tz, 1, 'months');
    const nextAfterNextMonth = getStartOf(nextMonth, 'month', tz, 1, 'months');

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, nextMonth, tz)),
      dispatch(fetchTimeSlots(listing.id, nextMonth, nextAfterNextMonth, tz)),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};

// Helper to fetch correct image variants for different thunk calls
const getImageVariants = listingImageConfig => {
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = listingImageConfig;
  const aspectRatio = aspectHeight / aspectWidth;
  return {
    'fields.image': [
      // Profile images
      'variants.square-small',
      'variants.square-small2x',

      // Listing images:
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
  };
};

const listingRelationship = txResponse => {
  return txResponse.data.data.relationships.listing.data;
};

export const fetchTransaction = (id, txRole, config) => (
  dispatch,
  getState,
  sdk
) => {
  dispatch(fetchTransactionRequest());
  let txResponse = null;

  return sdk.transactions
    .show(
      {
        id,
        include: [
          'customer',
          'customer.profileImage',
          'provider',
          'provider.profileImage',
          'listing',
          'listing.currentStock',
          'booking',
          'reviews',
          'reviews.author',
          'reviews.subject',
        ],
        ...getImageVariants(config.layout.listingImage),
      },
      { expand: true }
    )
    .then(response => {
      txResponse = response;
      const listingId = listingRelationship(response).id;
      const entities = updatedEntities({}, response.data);
      const listingRef = { id: listingId, type: 'listing' };
      const transactionRef = { id, type: 'transaction' };
      const denormalised = denormalisedEntities(entities, [
        listingRef,
        transactionRef,
      ]);
      const listing = denormalised[0];
      const transaction = denormalised[1];
      const processName = resolveLatestProcessName(
        transaction.attributes.processName
      );
      try {
        const process = getProcess(processName);
        const isInquiry =
          process.getState(transaction) === process.states.INQUIRY;

        // Fetch time slots for transactions that are in inquired state
        const canFetchTimeslots =
          txRole === 'customer' && isBookingProcess(processName) && isInquiry;

        if (canFetchTimeslots) {
          fetchMonthlyTimeSlots(dispatch, listing);
        }
      } catch (error) {
        console.log(`transaction process (${processName}) was not recognized`);
      }

      const metaLineItems = transaction?.attributes?.metadata?.lineItems || [];
      const itemListingIds = metaLineItems
        .map(li => getItemListingIdString(li?.itemListingId))
        .filter(Boolean);

      // Always try fetching the base listing too so we keep legacy behavior.
      const idsToFetch = Array.from(new Set([listingId, ...itemListingIds]));

      // If listing is deleted, listing.show may fail. We'll attempt each fetch and ignore failures.
      const fetches = idsToFetch.map(uuid =>
        sdk.listings
          .show({
            id: uuid,
            include: ['author', 'author.profileImage', 'images'],
            ...getImageVariants(config.layout.listingImage),
          })
          .catch(() => null)
      );

      return Promise.all(fetches);
    })
    .then(listings => {
      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };

      dispatch(addMarketplaceEntities(txResponse, {}));
      if (Array.isArray(listings)) {
        listings.filter(Boolean).forEach(r => dispatch(addMarketplaceEntities(r, {})));
      } else {
        dispatch(addMarketplaceEntities(listings, {}));
      }
      dispatch(fetchTransactionSuccess(txResponse));
      return txResponse;
    })
    .catch(e => {
      dispatch(fetchTransactionError(storableError(e)));
      throw e;
    });
};

const delay = ms => new Promise(resolve => window.setTimeout(resolve, ms));
const refreshTx = (sdk, txId) =>
  sdk.transactions.show({ id: txId }, { expand: true });
const refreshTransactionEntity = (sdk, txId, dispatch) => {
  delay(3000)
    .then(() => refreshTx(sdk, txId))
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      const lastTransition = response?.data?.data?.attributes?.lastTransition;
      // We'll make another attempt if mark-received-from-purchased from default-purchase process is still the latest.
      if (lastTransition === 'transition/mark-received-from-purchased') {
        return delay(8000)
          .then(() => refreshTx(sdk, txId))
          .then(response => {
            dispatch(addMarketplaceEntities(response));
          });
      }
    })
    .catch(e => {
      // refresh failed, but we don't act upon it.
      console.log('error', e);
    });
};

const getFirstImageUrl = (images = [], variant = 'default') => {
  if (images?.length > 0) {
    const img = images.find(img => img?.attributes?.variants?.[variant]);
    return img?.attributes?.variants?.[variant]?.url || '';
  }
  return '';
};

export const sendTransactionNotification = ({
  getState,
  txId,
  transitionName,
  transaction,
}) => {
  try {
    const { currentUser } = getState().user || {};
    const currentUserId = currentUser?.id?.uuid;
    const currentUserDisplayName = currentUser?.attributes?.profile?.displayName;

    if (!currentUser || !transaction) {
      console.error("Missing currentUser or transaction data");
      return;
    }

    const { customer, provider, listing } = transaction || {};
    const receiver = currentUserId === customer?.id?.uuid ? provider : customer;
    const isProvider = currentUserId === provider?.id?.uuid;
    const receiverId = receiver?.id?.uuid;

    if (!receiverId) {
      console.error("Missing receiver ID for push notification");
      return;
    }

    const itemName = listing?.attributes?.title || '';

    let image = '';
    try {
      image = getFirstImageUrl(listing?.images, 'listing-card') || '';
    } catch (err) {
      console.error("Failed to get listing image:", err);
    }

    const send = (templateKey, additionalData = {}) => {
      try {
        const template_id = oneSignalNotificationTemplates[templateKey];

        if (!template_id) {
          console.error(`Invalid OneSignal template key: ${templateKey}`);
          return;
        }

        const customData = {
          transactionId: txId?.uuid || txId,
          itemName,
          image,
          userName: currentUserDisplayName,
          senderName: currentUserDisplayName,
          url: `${process.env.REACT_APP_MARKETPLACE_ROOT_URL}/${isProvider ? "order" : "sale"}/${txId?.uuid || txId}`,
          ...additionalData,
        };

        const notificationParams = {
          receiverUserIds: [receiverId],
          senderUserId: currentUserId,
          template_id,
          notificationData: customData,
          customData,
        };

        onSendPushNotification(notificationParams);
      } catch (err) {
        console.error("Error sending push notification:", err);
      }
    };

    switch (transitionName) {
      case 'transition/accept':
      case 'transition/accept-after-payment':
        send('BOOKING_ACCEPTED_CUSTOMER');
        break;

      case 'transition/decline':
      case 'transition/decline-after-payment':
        send('BOOKING_DECLINED_CUSTOMER');
        break;

      case 'transition/review-1-by-provider':
      case 'transition/review-1-by-customer':
        send('REVIEW_RECEIVED');
        break;

      case 'transition/review-2-by-provider':
      case 'transition/review-2-by-customer':
        send('REVIEW_PUBLISHED_ON_PROFILE');
        break;

      case 'transition/inquire':
        send('TRANSACTION_INQUIRY_PROVIDER');
        break;

      case 'transition/request-payment':
      case 'transition/request-booking':
        send('BOOKING_REQUEST_PROVIDER');
        break;

      // transition/message notifications are sent server-side (messages.js cron)
      // with the exact iOS badge count included — do not send from the frontend.

      default:
        break;
    }
  } catch (err) {
    console.error("Unhandled error in sendTransactionNotification:", err);
  }
};

export const makeTransition = (txId, transitionName, params, transaction) => (
  dispatch,
  getState,
  sdk
) => {
  if (transitionInProgress(getState())) {
    return Promise.reject(new Error('Transition already in progress'));
  }
  dispatch(transitionRequest(transitionName));

  return sdk.transactions
    .transition(
      { id: txId, transition: transitionName, params },
      { expand: true }
    )
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(transitionSuccess());
      dispatch(fetchCurrentUserNotifications(getState().user.currentUser));
      sendTransactionNotification({ getState, txId, transitionName, transaction });

      // There could be automatic transitions after this transition
      // For example mark-received-from-purchased > auto-complete.
      // Here, we make 1-2 delayed updates for the tx entity.
      // This way "leave a review" link should show up for the customer.
      refreshTransactionEntity(sdk, txId, dispatch);

      if (transitionName === transitions.ACCEPT) {
        // Fetch current user, not use already fetched one as may contain obsolete data.
        sdk.currentUser.show().then(res => {
          const { data: currentUser } = res.data;
          const { publicData = {} } = currentUser.attributes.profile;
          const firstBookingDate = publicData.firstBookingDate || moment().toISOString();

          // Dispatch a single updateProfile call
          dispatch(
            updateProfile({
              publicData: {
                firstBookingDate,
              },
            })
          ).catch(() => {
            // Error is already handled via Redux state
            // This catch prevents unhandled promise rejection
          });
        }).catch(err => {
          console.error('Error fetching current user:', err);
        });
      }
      if (transitionName === transitions.ACCEPT_AFTER_PAYMENT_WITHOUT_VERIFICATION || transitionName === transitions.ACCEPT_WITHOUT_VERIFICATION) {
        updateAdminConfigAnalyticsDataApi({ isAccepetedWithoutVerification: true });
      }

      // Also, update record at Algolia to register recent
      // booking date.
      sdk.transactions
        .show({
          id: txId,
          include: ['listing'],
        })
        .then(txRes => {
          const { included } = txRes.data;
          const listing = (included || []).find(i => i != null && i.type === 'listing');
          const recordId = listing && listing.id ? listing.id.uuid : null;
          const defaultLanguage = listing?.attributes?.publicData?.defaultLanguage;

          if (recordId) {
            return updateAlgoliaData({
              indexName: getAlgoliaIndexNameForLang(defaultLanguage),
              data: {
                objectID: recordId,
                recentlyBookedAt: moment().toISOString(),
                recentlyBooked: moment().unix(),
              },
            });
          }
        })
        .catch(err => {
          console.log(err);
          console.log('Error: failed to record booking date to Algolia');
        });

      return response;
    })
    .catch(e => {
      dispatch(transitionError(storableError(e)));
      log.error(e, `${transitionName}-failed`, {
        txId,
        transition: transitionName,
      });
      throw e;
    });
};

const fetchMessages = (txId, page, config) => (dispatch, getState, sdk) => {
  const paging = { page, perPage: MESSAGES_PAGE_SIZE };
  dispatch(fetchMessagesRequest());

  return sdk.messages
    .query({
      transaction_id: txId,
      include: ['sender', 'sender.profileImage'],
      ...getImageVariants(config.layout.listingImage),
      ...paging,
    })
    .then(response => {
      const messages = denormalisedResponseEntities(response);
      const { totalItems, totalPages, page: fetchedPage } = response.data.meta;
      const pagination = { totalItems, totalPages, page: fetchedPage };
      const totalMessages = getState().TransactionPage.totalMessages;

      // Original fetchMessages call succeeded
      dispatch(fetchMessagesSuccess(messages, pagination));

      // Check if totalItems has changed between fetched pagination pages
      // if totalItems has changed, fetch first page again to include new incoming messages.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.
      if (totalItems > totalMessages && page > 1) {
        dispatch(fetchMessages(txId, 1, config))
          .then(() => {
            // Original fetch was enough as a response for user action,
            // this just includes new incoming messages
          })
          .catch(() => {
            // Background update, no need to to do anything atm.
          });
      }
    })
    .catch(e => {
      dispatch(fetchMessagesError(storableError(e)));
      throw e;
    });
};

export const fetchMoreMessages = (txId, config) => (
  dispatch,
  getState,
  sdk
) => {
  const state = getState();
  const { oldestMessagePageFetched, totalMessagePages } = state.TransactionPage;
  const hasMoreOldMessages = totalMessagePages > oldestMessagePageFetched;

  // In case there're no more old pages left we default to fetching the current cursor position
  const nextPage = hasMoreOldMessages
    ? oldestMessagePageFetched + 1
    : oldestMessagePageFetched;

  return dispatch(fetchMessages(txId, nextPage, config));
};

export const sendMessage = (txId, message, config, transaction, userType) => (
  dispatch,
  getState,
  sdk
) => {
  dispatch(sendMessageRequest());
  return sdk.messages
    .send({ transactionId: txId, content: message })
    .then(response => {
      const messageId = response.data.data.id;
      // We fetch the first page again to add sent message to the page data
      // and update possible incoming messages too.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.
      return dispatch(fetchMessages(txId, 1, config))
        .then(() => {
          dispatch(sendMessageSuccess());
          if (userType !== null) {
            // Send SMS from here to other party
            sendMessageNotificationToOtherPartyApi({ transactionId: txId.uuid, isProvider: userType === 'provider' });
          }
          sendTransactionNotification({ getState, txId, transitionName: "transition/message", transaction });
          return messageId;
        })
        .catch(() => dispatch(sendMessageSuccess()));
    })
    .catch(e => {
      dispatch(sendMessageError(storableError(e)));
      // Rethrow so the page can track whether the sending failed, and
      // keep the message in the form for a retry.
      throw e;
    });
};

// If other party has already sent a review, we need to make transition to
// transitions.REVIEW_2_BY_<CUSTOMER/PROVIDER>
const sendReviewAsSecond = (
  txId,
  transition,
  params,
  dispatch,
  sdk,
  config
) => {
  const include = REVIEW_TX_INCLUDES;

  return sdk.transactions
    .transition(
      { id: txId, transition, params },
      { expand: true, include, ...getImageVariants(config.layout.listingImage) }
    )
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(sendReviewSuccess());
      return response;
    })
    .catch(e => {
      dispatch(sendReviewError(storableError(e)));

      // Rethrow so the page can track whether the sending failed, and
      // keep the message in the form for a retry.
      throw e;
    });
};

// If other party has not yet sent a review, we need to make transition to
// transitions.REVIEW_1_BY_<CUSTOMER/PROVIDER>
// However, the other party might have made the review after previous data synch point.
// So, error is likely to happen and then we must try another state transition
// by calling sendReviewAsSecond().
const sendReviewAsFirst = (txId, transition, params, dispatch, sdk, config) => {
  const include = REVIEW_TX_INCLUDES;

  return sdk.transactions
    .transition(
      { id: txId, transition, params },
      { expand: true, include, ...getImageVariants(config.layout.listingImage) }
    )
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(sendReviewSuccess());
      return response;
    })
    .catch(e => {
      // If transaction transition is invalid, lets try another endpoint.
      if (isTransactionsTransitionInvalidTransition(e)) {
        return sendReviewAsSecond(id, params, role, dispatch, sdk);
      } else {
        dispatch(sendReviewError(storableError(e)));

        // Rethrow so the page can track whether the sending failed, and
        // keep the message in the form for a retry.
        throw e;
      }
    });
};

export const sendReview = (tx, transitionOptionsInfo, params, config) => (
  dispatch,
  getState,
  sdk
) => {
  const {
    reviewAsFirst,
    reviewAsSecond,
    hasOtherPartyReviewedFirst,
  } = transitionOptionsInfo;
  dispatch(sendReviewRequest());

  return hasOtherPartyReviewedFirst
    ? sendReviewAsSecond(tx?.id, reviewAsSecond, params, dispatch, sdk, config)
    : sendReviewAsFirst(tx?.id, reviewAsFirst, params, dispatch, sdk, config);
};

const isNonEmpty = value => {
  return typeof value === 'object' || Array.isArray(value)
    ? !isEmpty(value)
    : !!value;
};

export const fetchNextTransitions = id => (dispatch, getState, sdk) => {
  dispatch(fetchTransitionsRequest());

  return sdk.processTransitions
    .query({ transactionId: id })
    .then(res => {
      dispatch(fetchTransitionsSuccess(res.data.data));
    })
    .catch(e => {
      dispatch(fetchTransitionsError(storableError(e)));
    });
};

export const fetchTransactionLineItems = fetchLineItemsData => dispatch => {
  dispatch(fetchLineItemsRequest());
  return transactionLineItems(fetchLineItemsData)
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
      return lineItems;
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        orderData,
      });
    });
};

export const clearTxUnreadMessagesCount = (txId, role) => async (dispatch, getState, sdk) => {
  try {
    const currentUser = getState().user.currentUser;
    const validRoles = [UNREAD_MESSAGES_ROLE_ORDER, UNREAD_MESSAGES_ROLE_SALES];
    if (!currentUser?.id || !validRoles.includes(role)) {
      return;
    }
    const protectedData = currentUser.attributes.profile.protectedData;
    const unreadMessages = protectedData.unreadMessages || {};
    const txUnreadMessages = unreadMessages[role]?.[txId];
    // console.log({ unreadMessages, txUnreadMessages });
    const protectedDataUpdate = {
      unreadMessages: {
        ...unreadMessages,
        [role]: {
          ...unreadMessages[role],
          [txId]: 0,
        },
      },
    }
    if (txUnreadMessages) {
      await dispatch(updateProfile({ protectedData: protectedDataUpdate }));
      dispatch(fetchCurrentUserNotifications(getState().user.currentUser));
      // Sync iOS badge count after clearing unread messages (fire-and-forget)
      syncBadgeCount({ txId, role }).catch(err => console.error('Badge sync failed', err));
    }
  } catch (error) {
    console.error(error);
  }
}

// loadData is a collection of async calls that need to be made
// before page has all the info it needs to render itself
export const getAdminConfig = () => async (dispatch, getState, sdk) => {
  try {
    dispatch(fetchAdminConfigRequest());
    const response = await getAdminConfigApi();
    dispatch(fetchAdminConfigSuccess(response.data));
  } catch (error) {
    console.error(error);
    dispatch(fetchAdminConfigError(storableError(error)));
  }
}
export const refreshTransactionEntityAgain = (txId) => async (dispatch, getState, sdk) => {
  try {
    console.log('refreshTransactionEntityAgain', txId);
    dispatch(fetchCurrentUser()).then(res => {
      refreshTransactionEntity(sdk, txId, dispatch);
    })
  } catch (error) {
    console.error(error);
  }
}
export const isUsersEmailVerified = (transactionId = null, userId = null) => async (dispatch, getState, sdk) => {
  try {
    const response = await isUsersEmailVerifiedApi({ transactionId: transactionId?.uuid, userId: userId?.uuid });
    dispatch(setUsersEmailVerified(response));
  } catch (error) {
    console.error(error);
  }
}
export const sendEmailToSupport = (data) => async (dispatch, getState, sdk) => {
  try {
    await sendEmailToSupportApi(data);
    dispatch(sendEmailToSupportSuccess());
  } catch (error) {
    console.error('❌ Error in sendEmailToSupport', error);
    throw error;
  }
}
export const loadData = (params, search, config) => (dispatch, getState) => {
  const txId = new UUID(params.id);
  const state = getState().TransactionPage;
  const txRef = state.transactionRef;
  const txRole = params.transactionRole;

  // In case a transaction reference is found from a previous
  // data load -> clear the state. Otherwise keep the non-null
  // and non-empty values which may have been set from a previous page.
  const initialValues = txRef ? {} : pickBy(state, isNonEmpty);
  dispatch(setInitialValues(initialValues));

  // Page is auth-only/noindex. SSR fetches transaction + messages only; the
  // following are dispatched client-side from TransactionPage.js post-mount:
  //   fetchNextTransitions, stripeCustomer, getAdminConfig,
  //   isUsersEmailVerified, fetchExchangeRates, queryUserReviews
  return Promise.all([
    dispatch(fetchTransaction(txId, txRole, config)),
    dispatch(fetchMessages(txId, 1, config)),
  ]);
};
